<p class="accessDenied" *ngIf="isInvalidDomain">Unauthorized</p>
<!--<body>-->
  <!--<div class="headerContentArea" *ngIf="!isUserRegistered && !isInvalidDomain">
    <div class="logoArea">
      <div class="headerLftContent dispInlineBlock disableOutline" tabindex="-1" id="HeaderdeloitteLogo">
        <img class="deloitteLogo" src="../../assets/images/business_log.png" alt="Deloitte Logo on header">
        <span class="header-bischem-title">Business Chemistry</span>
      </div>
    </div>
  </div>-->
  <div class="content" *ngIf="!isUserRegistered && !isInvalidDomain">
    <div class="image">
      <img src="../../assets/images/bcLogo_round.svg" alt="Business Chemistry Logo">
    </div>
    <div class="message">
      <h1>Oops - looks like you missed a step!</h1>
      <p>
        To access the Admin Portal, you must first complete the Business Chemistry assessment to create your account.<br>
        Click this <a href="{{mainAppUrl}}" >link</a> to take the assessment and then return here to access the Admin Portal.
      </p>
    </div>

  </div>
<!--</body>-->


